import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

import BaseOrderView from './BaseOrderView';

const GRID_COLUMNS = [
  {
    field: 'instrumentId',
    columnHeader: strings.dataViewing.tableHeaders.instrumentId,
    width: '225px',
    sortable: true
  },
  {
    field: 'date',
    columnHeader: strings.dataViewing.tableHeaders.date,
    width: '225px',
    sortable: true
  },
  {
    field: 'price',
    columnHeader: strings.dataViewing.tableHeaders.price,
    width: '225px'
  },
  {
    field: 'aggrVol',
    columnHeader: strings.dataViewing.tableHeaders.aggrVol,
    width: '225px'
  },
  {
    field: 'marketMaker',
    columnHeader: strings.dataViewing.tableHeaders.marketMaker,
    width: '8em',
    required: false
  },
  {
    field: 'tradingSystem',
    columnHeader: strings.dataViewing.tableHeaders.tradingSystem,
    width: '8em',
    required: false
  },
  {
    field: 'tradingSystemPhase',
    columnHeader: strings.dataViewing.tableHeaders.tradingSystemPhase,
    width: '8em',
    required: false
  },
  {
    field: 'aggregatedQuotesAndOrder',
    columnHeader: strings.dataViewing.tableHeaders.aggregatedQuotesAndOrder,
    width: '8em',
    required: false
  }
];

const GRID_COLUMNS_UK = [
  {
    field: 'instrumentId',
    columnHeader: strings.dataViewing.tableHeaders.instrumentId,
    width: '225px',
    sortable: true
  },
  {
    field: 'date',
    columnHeader: strings.dataViewing.tableHeaders.date,
    width: '225px',
    sortable: true
  },
  {
    field: 'price',
    columnHeader: strings.dataViewing.tableHeaders.price,
    width: '225px'
  },
  {
    field: 'aggrVol',
    columnHeader: strings.dataViewing.tableHeaders.aggrVol,
    width: '225px'
  }
];

class DefaultOrderView extends Component {
  render() {
    const columns = this.props.order.venueLocation === 1 ? GRID_COLUMNS_UK : GRID_COLUMNS;
    return <BaseOrderView gridColumns={columns} {...this.props} />;
  }
}

export default DefaultOrderView;



// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/DefaultOrderView.jsx